document.addEventListener('magiczoomplus:beforeinit', function(){
  
  var $spin = document.querySelector('#sirv-spin div[data-id]');
  var $newSpin = $spin.outerHTML;
  var $sirvSpinUrl = $newSpin.replace(/.*data\-src="(.*?)".*/gmi, '$1');
  var $sirvSpinUrl2 = $sirvSpinUrl.replace(/\/([^\/]{1,})\.spin/gmi, '-2/$1-2.spin');
  var $sirvSpinUrl_id = $sirvSpinUrl.replace(/[^a-zA-Z0-9]/gmi,'');
  var $sirvSpinUrl2_id = $sirvSpinUrl2.replace(/[^a-zA-Z0-9]/gmi,'');

  $spin.parentNode.innerHTML = $spin.parentNode.innerHTML + '<div data-id="' + $sirvSpinUrl2_id + '" data-src="' + $sirvSpinUrl2 + '"></div>';

  

  window['initMagicScroll'] = function() {
    if (jQuery('#msc-selectors-container').length) {
        if (typeof window['MagicScrollStarts'] == 'undefined') {
          window['MagicScrollStarts'] = 0;
        }
        window['MagicScrollStarts']++;
        if (window['MagicScrollStarts'] == 2) {
          MagicScroll.start();
        }
    }
  }



window['mtInitSirvIcon'] = function (spinURL) {

  

  if (jQuery('.spin-icon-1').length) {
    return;
  }

    var $iconClass = '';

    if (SirvIconURL == 'gif-overlay' || SirvIconURL == 'giftwitch-overlay') {
        $iconClass = 'spin-overlay-icon';
    }

    if (SirvIconURL == 'gif' || SirvIconURL == 'gif-overlay') {
        SirvIconURL = spinURL + '?image'
    }
    if (SirvIconURL == 'giftwitch' || SirvIconURL == 'giftwitch-overlay') {
        SirvIconURL = spinURL + '?image.rules=R30L60R30&image.speed=1000&image.pause=3000'
    }

    $instance = Sirv.viewer.getInstance('#sirv-spin');

    SirvSetActiveItem(spinURL);


    jQuery('.MagicToolboxContainer').removeClass('no-thumbnails');
    jQuery('.MagicToolboxSelectorsContainer').show();

    jQuery('.MagicToolboxSlides .MagicToolboxSlides-arrow').show();

    var sizes = mtGetMaxSizes();
    var iconHTML = ' <a class="' + $iconClass + ' spin-icon-1" data-slide-id="spin" href="#"><img alt="360 view" src="' + SirvIconURL + '"/></a>';

    if (jQuery('.MagicToolboxSelectorsContainer a').length == 0) {
        jQuery('.MagicToolboxSlides .MagicToolboxSlides-arrow').hide();
        jQuery('.MagicToolboxSelectorsContainer').append(iconHTML);
    } else if (SirvSpinPosition == 'last') {
        jQuery('.MagicToolboxSelectorsContainer a:last').after(iconHTML);
    } else if (SirvSpinPosition == 'second') {
        jQuery('.MagicToolboxSelectorsContainer a:first').after(iconHTML);
    } else {
        jQuery('.MagicToolboxSelectorsContainer a:first').before(iconHTML);
    }

    if (jQuery('.MagicToolboxContainer').hasClass('layout-bottom')) {
        jQuery('#SirvIcon').css('height', sizes.height + 'px').show();
    } else {
        jQuery('#SirvIcon').css('width', sizes.width + 'px').show();
    }

    mtInitSelectors('.MagicToolboxSelectorsContainer a[data-slide-id="spin"]');

    if (SirvSpinPosition == 'first') {
        if (SirvVariants[currentVariantID]) {
            mtShowSirvVariant(currentVariantID);
            currentVariantID = 0;
        } else {
            jQuery('.MagicToolboxSelectorsContainer a[data-slide-id="spin"]').trigger('click');
        }
    }

    if (jQuery('.MagicToolboxSelectorsContainer a').length == 0) {
        jQuery('.MagicToolboxContainer').addClass('no-thumbnails');
        jQuery('.MagicToolboxSlides .MagicToolboxSlides-arrow, .MagicToolboxSelectorsContainer').hide();
        jQuery('div[data-slide-id="zoom"]').removeClass('active-magic-slide');
        jQuery('div[data-slide-id="spin"]').addClass('active-magic-slide');
        Sirv.start();

    }

    //initMagicScroll();
}





  
  window['mtInitSirv_old'] = window['mtInitSirv'];
  window['mtInitSirv'] = function() {
    mtInitSirv_old();

    var spinURL = $sirvSpinUrl2;

            jQuery.ajax({
                url: spinURL,
                type: 'HEAD',
                cache: true,
                timeout: 4000,
                error: function(jqXHR, textStatus, errorThrown) {
                    initMagicScroll();
                },
                success: function(data, textStatus, jqXHR) {

                  
                    
                    var $iconClass = '';

                      $iconClass = 'spin-overlay-icon';

                      SirvIconURL = spinURL + '?image'

                    if (SirvIconURL == 'giftwitch' || SirvIconURL == 'giftwitch-overlay') {
                        SirvIconURL = spinURL + '?image.rules=R30L60R30&image.speed=1000&image.pause=3000'
                    }

                    jQuery('.MagicToolboxContainer').removeClass('no-thumbnails');
                    jQuery('.MagicToolboxSelectorsContainer').show();

                    jQuery('.MagicToolboxSlides .MagicToolboxSlides-arrow').show();

                    var sizes = mtGetMaxSizes();
                    var iconHTML = ' <a class="' + $iconClass + ' second-spin" data-slide-id="spin" data-spin-id="' + $sirvSpinUrl2 + '" href="#"><img alt="360 view" id="SirvIcon" x-style="display:none;" src="' + SirvIconURL + '"/></a>';

                    jQuery('a[data-slide-id="spin"], .MagicToolboxSelectorsContainer a:first').last().after(iconHTML);


                    mtInitSelectors('.MagicToolboxSelectorsContainer a.second-spin');

                    initMagicScroll();

                    jQuery('a[data-slide-id="spin"]').on((mzOptions && mzOptions.selectorTrigger && mzOptions.selectorTrigger == 'hover') ? 'mouseover click touchend' : 'click touchend', function(e) {
                        $instance = Sirv.viewer.getInstance('#sirv-spin');
                        if (typeof jQuery(this).attr('data-spin-id') == 'undefined') {
                          SirvSetActiveItem($sirvSpinUrl);
                        } else {
                          SirvSetActiveItem( jQuery(this).attr('data-spin-id') );
                        }
                        
                        e.preventDefault();
                    });

                },
            });

  }

});
